module.exports = __webpack_public_path__ + "static/media/caution.5e88a2e7.svg";